/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */

var $ = require("jquery");

$(".block-background-layer iframe").wrapAll('<div class=iframe-container></div>')